import { useState } from "react";
import { Bookmark, BookmarkCheck, Loader2 } from "lucide-react";
import { toast } from "sonner";

import { Button } from "@/components/ui/button";
import { normalizeSaved } from "@/lib/coreShapes";
import { useCore } from "../useCore";
import { runAction } from "../actions";
import { ErrorNote, btnOutline } from "./kit";

// Save / unsave an activity via the existing Core endpoints; saving is never a participation.
export function SaveToggle({ activityId }) {
  const saved = useCore("/member/saved-activities", (d) => ({ list: normalizeSaved(d) }));
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  if (saved.error || (saved.data && saved.data.list === null)) {
    return <p className="text-sm text-brand-purple/75" data-testid="save-toggle-unavailable">Die Merkliste ist gerade nicht abrufbar.</p>;
  }
  if (!saved.data) return null;
  const isSaved = saved.data.list.some((a) => String(a.id) === String(activityId));
  const toggle = async () => {
    setBusy(true); setError("");
    const err = await runAction(isSaved ? "delete" : "post", `/member/saved-activities/${activityId}`, isSaved ? "Das Entfernen von der Merkliste wurde nicht gespeichert" : "Das Merken wurde nicht gespeichert");
    setBusy(false);
    if (err) setError(err); else { toast.success(isSaved ? "Von der Merkliste entfernt." : "Gemerkt. Das ist keine Teilnahme."); saved.reload(); }
  };
  return (
    <div className="space-y-2">
      <Button variant="outline" onClick={toggle} disabled={busy} aria-pressed={isSaved} data-testid="activity-save-toggle" data-saved={isSaved} className={`min-h-[44px] ${btnOutline}`}>
        {busy ? <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" /> : isSaved ? <BookmarkCheck className="h-4 w-4" aria-hidden="true" /> : <Bookmark className="h-4 w-4" aria-hidden="true" />}
        {isSaved ? "Gemerkt – entfernen" : "Merken"}
      </Button>
      {error && <ErrorNote testid="activity-save-error">{error}</ErrorNote>}
    </div>
  );
}
